import React from "react";
import ReactDOM from "react-dom";
import { HashRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import "./utils/i18n";
import { unregister } from './registerServiceWorker';
import "babel-polyfill";

ReactDOM.render(
	<HashRouter>
		<App />
	</HashRouter>,
	document.getElementById("root")
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js